import React, { useState, ReactElement, Component, useContext, useEffect, useMemo } from "react";
import { injectIntl } from "react-intl";
import "./workspaces.less";
import { Row, Col } from "antd";
import { left_menu_item, LeftMenuContext, menu_items } from "../../contexts/left-menu";
import { Link, withRouter } from "react-router-dom";
// import { key_to_title } from "../../components/left-menu/left-menu";
import { permissions } from "../../permissions";
// import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { item } from "../../contexts/items";

const UseMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const left_menu_items: left_menu_item[] = useContext(LeftMenuContext)[0],
    [active_key, set_active_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(""),
    // user_info: IUserInfoType = useContext(UserInfoContext)[0],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    path = useMemo(() => props.history.location.pathname.substring(1).substring(props.history.location.pathname.substring(1).indexOf("/") + 1), [
      props.history.location.pathname,
    ]),
    { formatMessage } = useMemo(() => props.intl, [props.intl]),
    menu_new: JSX.Element[] = useMemo((): JSX.Element[] => {
      const menu_new_new: JSX.Element[] = [],
            path_full: string = props.history.location.pathname;
      const left_menu_items_new: left_menu_item[] =  
      (left_menu_items.filter((item:left_menu_item) => item.key !== "kubernetes")).length === 0 ? 
       path_full.includes("cluster-info/workspaces") ? menu_items[7] : path_full.includes("workspace-info/namespaces") ? menu_items[2] : 
       path_full.includes("namespace-info/workloads") ? menu_items[7] : left_menu_items : left_menu_items;
      for (let i = 0; i < left_menu_items_new.length; i++) {
        const menu_item: any = left_menu_items_new[i].key,
          level: string = `${(path_full.match(/\/(.*)-info\//) || [])[1]}`,
          permission: number = ((( cluster_selected?.labels?.role && cluster_selected?.labels?.role !== "" && (permissions[`${level}s`] || permissions[`${level}`])[cluster_selected?.labels?.role]) || new Int32Array()) as Int32Array)[3];
        if ((permission === 0 && menu_item !== "overview") || permission > 0)
          menu_new_new.push(
            <Col className="mt-10" sm={24} key={menu_item}>
              <Link to={menu_item}>
                <div
                  className={`left_menu_button w-110 ${active_key === menu_item ? "active" : ""} text-left`}
                  onClick={() => {
                    set_active_key(menu_item);
                  }}
                >{`${menu_item === "overview" ? formatMessage({ id: level }) : ""}${formatMessage({ id:  (menu_item === "overview" ? "_overview" : menu_item) || "version" })}`}</div>
              </Link>
            </Col>
          );
      }
      return menu_new_new;
      // eslint-disable-next-line
    }, [left_menu_items, cluster_selected?.labels?.role, active_key, formatMessage, props.history.location.pathname, cluster_selected]);

  useEffect(() => {
    set_active_key(path);
  }, [set_active_key, path]);

  return <Row>{menu_new}</Row>;
};

export default injectIntl(withRouter(UseMenu) as any);
